export const DEFAULT_CRITERIA_MANIFESTATION_IMAGE_LIMIT = 5;
export const DEFAULT_CRITERIA_MANIFESTATION_IMAGE_CAPTION_LIMIT = 75;
